export default __webpack_public_path__ + "static/2-a5ff61cbb38fc53509b7fb1cd8dc2126.png";